(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dd-hero"] && !Shopify.designMode) return;
  try {
    
  /* DD · Hero — el corte móvil se sirve solo donde de verdad calza, y eso pide DOS condiciones.
     Hacen falta las dos; ninguna sola alcanza (medido, no supuesto):

     1) El breakpoint de 900px, que es donde esta sección cambia de layout. Arriba de 900px el
        media deja de ser una banda ancha y se vuelve una columna a sangre de 52-56vw por el
        alto completo del hero: a 1440px la caja mide 749x975, o sea r=0.77 — MÁS vertical que
        la de un teléfono. Filtrar solo por proporción le serviría el archivo de 720px a
        escritorio, donde la caja mide 749 CSS px (1498 físicos en DPR 2) y se vería suave.

     2) La proporción de la caja, porque debajo de 900px la forma todavía cambia mucho:
        .dd-hero__frame es 100vw x clamp(340px, 54vh, 520px), así que da r~0.83-0.86 en teléfono
        vertical (el corte calza), pero r~1.43-1.48 en iPad y foldable abierto y r~2.48 en
        teléfono horizontal. Ahí el corte saldría con zoom de 43-66%. Un breakpoint solo no los
        distingue: los tres caen dentro de los 900px.

     Umbral 0.95: pasando de ahí `cover` empieza a comerse el borde inferior del corte, que es
     justo donde está el disco. Sin caja con layout → Infinity → cae al video de escritorio,
     que es el lado seguro. Orden de la lista = failover nativo del navegador: solo baja el
     siguiente si el anterior falla (429/404/5xx), nunca los dos. */
  (function () {
    var videos = document.querySelectorAll('.dd-hero__video');
    for (var i = 0; i < videos.length; i++) {
      var v = videos[i];
      if (v.querySelector('source')) { continue; }

      var frame = v.closest('.dd-hero__frame');
      var ratio = Infinity;
      if (frame && frame.clientHeight > 0) { ratio = frame.clientWidth / frame.clientHeight; }
      var narrow = window.matchMedia('(max-width: 900px)').matches;

      var list = [];
      var mobile = v.getAttribute('data-src-mobile');
      if (mobile && narrow && ratio <= 0.95) { list.push(mobile); }
      if (v.getAttribute('data-src')) { list.push(v.getAttribute('data-src')); }
      if (v.getAttribute('data-src-fallback')) { list.push(v.getAttribute('data-src-fallback')); }
      if (!list.length) { continue; }

      for (var j = 0; j < list.length; j++) {
        var source = document.createElement('source');
        source.src = list[j];
        source.type = 'video/mp4';
        v.appendChild(source);
      }
      /* Solo load(): reanuda la selección de recurso ahora que sí hay <source>, y deja
         intacta la bandera can-autoplay, así que el atributo autoplay nativo hace su
         trabajo. NO llamar play(): en una pestaña en segundo plano Chrome lo rechaza
         ("video-only background media was paused to save power") y, por haberse invocado,
         el autoplay nativo ya no lo retoma al volver a la pestaña — el hero se queda
         congelado en el frame 0. Medido: con play() paused=true; sin él, reproduce. */
      v.load();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
